/**
 * Triggers window location for select options.
 *
 * @param {element} selectElement - Select element.
 **/
export default function select( selectElement ) {
  selectElement.addEventListener( 'change', e => {
    var target = e.target.options[e.target.selectedIndex].dataset.target

    if ( target ) {
      window.location.href = target
    }
  })
}
